import React from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { RadioButton } from "primereact/radiobutton";
import localeText from "../../../../../locale";
import StoreSettingsFieldRow from "./StoreSettingsFieldRow";

const FREIGHT_RULES = [
  { id: "DISCOUNTPERCENTUAL", value: "DISCOUNTPERCENTUAL", label: "discountPercentual" },
  { id: "DISCOUNTABSOLUT", value: "DISCOUNTABSOLUT", label: "discountAbsolut" },
  { id: "FREE", value: "FREE", label: "free" },
];

const StoreSettingsLocationTab = ({
  siteLink,
  setSiteLink,
  facebookLink,
  setFacebookLink,
  twitterLink,
  setTwitterLink,
  instagramLink,
  setInstagramLink,
  youtubeLink,
  setYoutubeLink,
  linkedin,
  setLinkedin,
  tiktok,
  setTiktok,
  freightRule,
  setFreightRule,
  freightDiscount,
  setFreightDiscount,
  minimumOrderValue,
  setMinimumOrderValue,
  loadingFreight,
  onSave,
  saving,
}) => (
  <div className="flex flex-column gap-2">
    <StoreSettingsFieldRow
      label={localeText("website")}
      help={localeText("storeSettingsWebsiteHelp")}
    >
      <InputText
        value={siteLink}
        onChange={(e) => setSiteLink(e.target.value)}
        placeholder={localeText("website")}
        className="w-full"
      />
    </StoreSettingsFieldRow>
    <hr
      className="my-4"
      style={{ borderColor: "color-mix(in srgb, var(--theme-border) 50%, transparent)" }}
    />
    <StoreSettingsFieldRow label="Facebook" help={localeText("storeSettingsSocialHelp")}>
      <div className="p-inputgroup border-round-md">
        <span className="p-inputgroup-addon" style={{ color: "var(--theme-text-muted)" }}>
          https://facebook.com/
        </span>
        <InputText
          value={facebookLink}
          onChange={(e) => setFacebookLink(e.target.value)}
          placeholder="Facebook"
          className=""
        />
      </div>
    </StoreSettingsFieldRow>
    <hr
      className="my-4"
      style={{ borderColor: "color-mix(in srgb, var(--theme-border) 50%, transparent)" }}
    />
    <StoreSettingsFieldRow label="Twitter" help={localeText("storeSettingsSocialHelp")}>
      <div className="p-inputgroup border-round-md">
        <span className="p-inputgroup-addon" style={{ color: "var(--theme-text-muted)" }}>
          https://twitter.com/
        </span>
        <InputText
          value={twitterLink}
          onChange={(e) => setTwitterLink(e.target.value)}
          placeholder="Twitter"
          className=""
        />
      </div>
    </StoreSettingsFieldRow>
    <hr
      className="my-4"
      style={{ borderColor: "color-mix(in srgb, var(--theme-border) 50%, transparent)" }}
    />
    <StoreSettingsFieldRow label="Instagram" help={localeText("storeSettingsSocialHelp")}>
      <div className="p-inputgroup border-round-md">
        <span className="p-inputgroup-addon" style={{ color: "var(--theme-text-muted)" }}>
          https://instagram.com/
        </span>
        <InputText
          value={instagramLink}
          onChange={(e) => setInstagramLink(e.target.value)}
          placeholder="Instagram"
          className=""
        />
      </div>
    </StoreSettingsFieldRow>
    <hr
      className="my-4"
      style={{ borderColor: "color-mix(in srgb, var(--theme-border) 50%, transparent)" }}
    />
    <StoreSettingsFieldRow label="YouTube" help={localeText("storeSettingsSocialHelp")}>
      <div className="p-inputgroup border-round-md">
        <span className="p-inputgroup-addon" style={{ color: "var(--theme-text-muted)" }}>
          https://youtube.com/
        </span>
        <InputText
          value={youtubeLink}
          onChange={(e) => setYoutubeLink(e.target.value)}
          placeholder="YouTube"
          className=""
        />
      </div>
    </StoreSettingsFieldRow>
    <hr
      className="my-4"
      style={{ borderColor: "color-mix(in srgb, var(--theme-border) 50%, transparent)" }}
    />
    <StoreSettingsFieldRow label="LinkedIn" help={localeText("storeSettingsSocialHelp")}>
      <div className="p-inputgroup border-round-md">
        <span className="p-inputgroup-addon" style={{ color: "var(--theme-text-muted)" }}>
          https://linkedin.com/company/
        </span>
        <InputText
          value={linkedin}
          onChange={(e) => setLinkedin(e.target.value)}
          placeholder="LinkedIn"
          className=""
        />
      </div>
    </StoreSettingsFieldRow>
    <hr
      className="my-4"
      style={{ borderColor: "color-mix(in srgb, var(--theme-border) 50%, transparent)" }}
    />
    <StoreSettingsFieldRow label="TikTok" help={localeText("storeSettingsSocialHelp")}>
      <div className="p-inputgroup border-round-md">
        <span className="p-inputgroup-addon" style={{ color: "var(--theme-text-muted)" }}>
          https://tiktok.com/
        </span>
        <InputText
          value={tiktok}
          onChange={(e) => setTiktok(e.target.value)}
          placeholder="TikTok"
          className=""
        />
      </div>
    </StoreSettingsFieldRow>
    <hr
      className="my-4"
      style={{ borderColor: "color-mix(in srgb, var(--theme-border) 50%, transparent)" }}
    />
    <StoreSettingsFieldRow
      label={localeText("feightRules")}
      help={localeText("setShippingRulesForYourStore")}
    >
      {loadingFreight ? (
        <div className="flex align-items-center gap-2">
          <i className="pi pi-spin pi-spinner" />
          <span>{localeText("loading") || "A carregar..."}</span>
        </div>
      ) : (
        <div className="flex flex-column gap-3">
          <div className="flex flex-wrap gap-3">
            {FREIGHT_RULES.map(({ id, value, label }) => (
              <div key={id} className="flex align-items-center">
                <RadioButton
                  inputId={id}
                  value={value}
                  onChange={(e) => setFreightRule(e.value)}
                  checked={freightRule === value}
                />
                <label htmlFor={id} className="pl-2 cursor-pointer">
                  {localeText(label)}
                </label>
              </div>
            ))}
          </div>
          <StoreSettingsFieldRow
            label={localeText("minimalOrderValueToActivateSetting")}
            help={localeText("storeSettingsMinOrderHelp")}
          >
            <InputNumber
              mode="currency"
              currency="EUR"
              locale="de-DE"
              className="w-full"
              value={minimumOrderValue}
              onValueChange={(e) => setMinimumOrderValue(e.value)}
            />
          </StoreSettingsFieldRow>
          {(freightRule === "DISCOUNTPERCENTUAL" || freightRule === "DISCOUNTABSOLUT") && (
            <StoreSettingsFieldRow
              label={
                freightRule === "DISCOUNTPERCENTUAL"
                  ? `${localeText("percentual") || "Percentual"} (%)`
                  : localeText("value")
              }
              help={localeText("storeSettingsFreightValueHelp")}
            >
              {freightRule === "DISCOUNTPERCENTUAL" && (
                <InputNumber
                  value={freightDiscount}
                  onValueChange={(e) => setFreightDiscount(e.value)}
                  suffix="%"
                  mode="decimal"
                  className="w-full"
                  min={0}
                  max={100}
                />
              )}
              {freightRule === "DISCOUNTABSOLUT" && (
                <InputNumber
                  mode="currency"
                  currency="EUR"
                  locale="de-DE"
                  className="w-full"
                  value={freightDiscount}
                  onValueChange={(e) => setFreightDiscount(e.value)}
                />
              )}
            </StoreSettingsFieldRow>
          )}
        </div>
      )}
    </StoreSettingsFieldRow>
    <hr
      className="my-4"
      style={{ borderColor: "color-mix(in srgb, var(--theme-border) 50%, transparent)" }}
    />
    <div className="flex justify-content-end">
      <Button
        label={localeText("save")}
        onClick={onSave}
        loading={saving}
        className="w-auto border-round-md"
        style={{ backgroundColor: "var(--theme-primary)", color: "#fff", border: "none" }}
      />
    </div>
  </div>
);

export default StoreSettingsLocationTab;
